import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Wrapper } from '../../components';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
//import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
//import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

const columnData = [
  { id: 'name', numeric: false, disablePadding: false, label: 'Office' },
  { id: 'city', numeric: false, disablePadding: false, label: 'City' },
  { id: 'totalAreaPlain', numeric: true, disablePadding: false, label: 'Total area' },
  { id: 'availabilityPlain', numeric: true, disablePadding: false, label: 'Availability' },
  { id: 'views', numeric: true, disablePadding: false, label: 'Views' },
  { id: 'enquiriesCount', numeric: true, disablePadding: false, label: 'Enquiries' },
];

class OfficesTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

OfficesTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let OfficesTableToolbar = props => {
  const { classes } = props;

  return (
    <Toolbar
      className={classNames(classes.root)}
    >
      <div className={classes.title}>
        <Typography variant="title" id="tableTitle">
          Offices
        </Typography>
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {/*<Tooltip title="Filter list">
          <IconButton aria-label="Filter list">
            <FilterListIcon />
          </IconButton>
        </Tooltip>*/}
      </div>
    </Toolbar>
  );
};

OfficesTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired
};

OfficesTableToolbar = withStyles(toolbarStyles)(OfficesTableToolbar);

const styles = theme => ({
  root: {
    width: '100%'
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  rowHeader: {
  	fontWeight: '500',
    //cursor: 'pointer'
  },
  center: {
  	textAlign: 'center'
  }
});

class OfficesTable extends React.Component {
  constructor(props) {
    super(props);

    const { offices } = this.props;
    const officesData = Object.values(offices)

    this.state = {
      order: 'asc',
      orderBy: 'name',
      data: officesData.sort((a, b) => a.name.localeCompare(b.name)),
      page: 0,
      rowsPerPage: 10,
    };
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    let data = []

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    if (orderBy === 'totalAreaPlain' || orderBy === 'availabilityPlain' || orderBy === 'views' || orderBy === 'enquiriesCount') {
      data =
        order === 'desc'
          ? this.state.data.sort((a, b) => (parseInt(b[orderBy], 10) < parseInt(a[orderBy], 10) ? -1 : 1))
          : this.state.data.sort((a, b) => (parseInt(a[orderBy], 10) < parseInt(b[orderBy], 10) ? -1 : 1));
    } else {
      data =
        order === 'desc'
          ? this.state.data.sort((a, b) => b[orderBy].localeCompare(a[orderBy]))
          : this.state.data.sort((a, b) => a[orderBy].localeCompare(b[orderBy]));
    }

    this.setState({ data, order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
    	<Wrapper>
        <Paper className={classes.root}>
          <OfficesTableToolbar />
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <OfficesTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
              <TableBody>
                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(office => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={office.id}
                    >
                      <TableCell component="th" scope="row" className={classes.rowHeader}>
                        <Link to={`/office/${office.id}`}>
                          {office.name}
                        </Link>
                      </TableCell>
                      <TableCell>{office.city}</TableCell>
                      <TableCell numeric>{office.totalAreaPlain}</TableCell>
                      <TableCell numeric>{office.availabilityPlain ? `${office.availabilityPlain}%` : '-'}</TableCell>
                      <TableCell numeric>{office.views}</TableCell>
                      <TableCell numeric>{office.enquiriesCount}</TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
          />
        </Paper>
      </Wrapper>
    );
  }
}

OfficesTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps ({ offices }) {
  return {
    offices
  }
}

export default connect(mapStateToProps)(withStyles(styles)(OfficesTable))


// WEBPACK FOOTER //
// ./src/components/Offices/Offices.js